export default {
  test: '후오비 테스트',
};


// WEBPACK FOOTER //
// ./src/locales/ko-KR/test.ts